const companyChildren = [
  {
    label: 'About Us',
    path: '/about-us',
  },
  {
    label: 'Reviews',
    path: '/testimonials',
  },
  {
    label: 'Privacy',
    path: '/privacy-policy',
  },
  {
    label: 'Contact Us',
    path: '/contact-us',
  },
  {
    label: 'Prices',
    path: '/fees',
  },
  {
    label: 'London Employment Solicitors',
    path: '/london-employment-solicitors',
  },
  {
    label: 'Our Team',
    path: '/team',
  },
  {
    label: 'Complaints',
    path: '/complaints',
  },
];

export default companyChildren;
